import React, { Component } from "react";
import logo from "../images/boem_logo.avif";
import Scrollspy from "react-scrollspy";

class Header extends Component {
  state = {
    prevScrollPos: 0,
    borderedHeader: false,
    hideHeader: false,
    hideLogo: false
  };

  menu = (
    <Scrollspy
      items={["topBanner", "about", "quiz", "stickerPack"]}
      currentClassName="current-section"
      className="menu-scrollspy"
    >
      <li>
        <a
          href="#topBanner"
          onClick={(e) => this.props.scrollTo(e, "sectionTopBanner")}
        >
          Home
        </a>
      </li>
      <li>
        <a
          href="#about"
          onClick={(e) => this.props.scrollTo(e, "sectionAbout")}
        >
          About
        </a>
      </li>
      <li>
        <a
          href="#quiz"
          onClick={(e) => this.props.scrollTo(e, "sectionQuiz")}
        >
          Quiz
        </a>
      </li>
      <li>
        <a
          href="#stickerPack"
          onClick={(e) => this.props.scrollTo(e, "sectionStickerPack")}
        >
          StickerPack
        </a>
      </li>
    </Scrollspy>
  );

  onScroll = () => {
    var currentScrollPos = window.pageYOffset;
    var hide = false;
    var hideLogo = false;
    var bordered = false;

    if (currentScrollPos > 10) {
      bordered = true;
    }

    if (this.state.prevScrollPos > currentScrollPos) {
      if(currentScrollPos > 90) {
        hide = true;
      }
      hide = false;
    } else if (currentScrollPos > 350) {
      hide = true;
    }

    this.setState({
      prevScrollPos: currentScrollPos,
      hideHeader: hide,
      borderedHeader: bordered,
      hideLogo: hideLogo
    });
  };

  componentDidMount() {
    window.addEventListener("scroll", this.onScroll, 10);
  }

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.onScroll);
  };

  render() {
    return (
      <header
        className={
          "header" +
          (this.state.borderedHeader ? " border-bottom" : "") +
          (this.state.hideHeader & this.props.hideMobileMenu
            ? " hide-to-top"
            : "") +
            (this.state.hideLogo & this.props.hideMobileMenu
              ? " hide-logo-to-top"
              : "") +
          (this.props.hideMobileMenu ? "" : " fixed")
        }
      >
        <div className="header-right">
          <div className="logo">
            <img src={logo} alt="Hand-drawn illustration of Bandit the chinchilla sitting behind a small laptop"/>
            <h1>Chaos Chinchillas</h1>
          </div>
          <div>
          <button
            className="toggle-menu-btn"
            onClick={(e) => this.props.toggleMobileMenu(false)}
          >
            <i className="fa fa-bars" />
          </button>

          <div className="navigation" role="navigations">
            <ul>
            {this.menu}
            </ul>
          </div>

          <div
          className={
            "backdrop" + (this.props.hideMobileMenu ? " hide" : " show")
          }
        />

        <div
          className={
            "mobile-menu" + (this.props.hideMobileMenu ? " hide" : " show")
          }
        >
          <button
            className="toggle-menu-btn"
            onClick={(e) => this.props.toggleMobileMenu(true)}
          >
            <i className="fa fa-times" />
          </button>
          {this.menu}
        </div>

        </div></div>
        <div className="social-links">
          <a
            href="https://www.facebook.com/chaoschinchillas/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <i className="fab fa-facebook" />
          </a>
          <a
            href="https://www.instagram.com/chaos_chinchillas/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <i className="fab fa-instagram" />
          </a>
        </div>
      </header>
    );
  }
}

export default Header;
